var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "ui-content__item-page ui-layout ui-item-page" },
      [
        _c("h2", { staticClass: "ui-item-page__title" }, [_vm._v("UI")]),
        _c("div", { staticClass: "ui-block" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-12" }, [
              _c("h5", { staticClass: "ui-item-page__sub-title" }, [
                _vm._v("01 Grid"),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
                _c("div", { staticClass: "col-md-1" }, [
                  _c("div", { staticClass: "ui-col" }),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }